
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TicketsModule } from '@/store/modules/tickets'
import { IssuesModule } from '@/store/modules/issues'
import { ORDERAPI } from '@/api/orders'
import { getuserCurrentApp } from '@/utils/cookies'
import { AppModule, DeviceType } from '@/store/modules/app'
import { isAgentMobile } from '@/utils/validate'
import VuePicker from 'vue-pickers'

interface IFormdata {
  description: string,
  handler: string,
  groupId: Array<number>,
  forwardType: number
}

const defaultRole: IFormdata = {
  description: '',
  handler: '',
  groupId: [],
  forwardType: 1 // 1 组内转接，2 组外转接
}

@Component({
  name: 'ForwardDialog',
  components: {
    VuePicker
  }
})
export default class extends Vue {

  private forwardDialog = Object.assign({}, defaultRole)
  private rules = {
    description: [{ required: true, message: '请输入转接描述', trigger: 'change' }],
    handler: [{ required: true, message: '请选择工单接收人', trigger: 'change' }],
    groupId: [{ required: true, message: '请选择转接群组', trigger: 'change' }],
    forwardType: [{ required: true, message: '请选择转接类型', trigger: 'change' }]
  }

  private btnLoading = false
  private forwardGroupOptions = [] // 待转接群组
  private pickerGroupVisible = false // 点击群组选择，显示picker联动
  private pickerGroupCn = '' // 移动端：转接组名称

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  // 受理人
  get handlerList() {
    return IssuesModule.handlerList
  }

  get dialogVisible() {
    return TicketsModule.forwardDialog
  }

  get currentTicket() {
    return TicketsModule.currentTicket
  }

  get device() {
    return AppModule.device
  }

  get isMobile() {
    return this.device === DeviceType.Mobile
  }

  get isAgentMobile() {
    return isAgentMobile()
  }

  @Watch('dialogVisible')
  private onDialogStatusChange(value: boolean) {
    if (value) { // 打开弹框
      // 调用受理人接口
      IssuesModule.SetHandler(this.userCurrentApp)
      this.forwardDialog = Object.assign({}, defaultRole)
      this.pickerGroupCn = ''
      this.$nextTick(() => {
        if (this.$refs['forwardDialog']) {
          (this.$refs['forwardDialog'] as any).clearValidate()
        }
      })
      this.getForwardGroup()
    }
  }

  // 获取待转接群组数据
  private getForwardGroup() {
    ORDERAPI.getForwardGroup({
      app_id: this.userCurrentApp
    }).then(res => {
      this.forwardGroupOptions = res.data
    }).catch(() => {
      console.log('request error!')
    })
  }

  // 关闭弹框
  private handleClose() {
    // (this.$refs.blurSelect as any).blur()
    TicketsModule.ToggleDialogStatus({
      name: 'forwardDialog',
      value: false
    })
  }

  // 转接
  private handleForwardSubmit() {
    const form: any = this.$refs['forwardDialog']
    if (this.forwardDialog.forwardType === 1) {
      form.validate(async (valid: boolean) => {
        if (valid) {
          this.btnLoading = true
          ORDERAPI.forwardTicket({
            tid: this.currentTicket.tid,
            t_type: this.currentTicket.ticket_type,
            forward_user_workcode: this.forwardDialog.handler,
            description: this.forwardDialog.description
          }, {
            app_id: this.userCurrentApp
          }).then((res: any) => {
            this.btnLoading = false
            this.handleClose()
            this.$message({
              message: res.data,
              type: 'success',
              showClose: true
            })
            this.$router.replace({ name: 'home' })
          }).catch(() => {
            this.btnLoading = false
          })
        } else {
          return false
        }
      })
    } else {
      form.validate(async (valid: boolean) => {
        if (valid) {
          this.btnLoading = true
          ORDERAPI.forwardGroupTicket({
            tid: this.currentTicket.tid,
            t_type: this.currentTicket.ticket_type,
            group_id: this.forwardDialog.groupId[1],
            description: this.forwardDialog.description
          }, {
            app_id: this.userCurrentApp
          }).then((res: any) => {
            if (res.stat === 1) {
              this.btnLoading = false
              this.handleClose()
              this.$message({
                message: res.data,
                type: 'success',
                showClose: true
              })
              this.$router.replace({ name: 'home' })
            } else {
              this.$message({
                message: res.data,
                type: 'error',
                showClose: true
              })
            }
          }).catch(() => {
            this.btnLoading = false
          })
        } else {
          return false
        }
      })
    }
  }

  // 移动端：转接群组联动确认
  private confirmChangeGroup(res: any) {
    const groupIds: string[] = []
    res.map((item: { label: string }) => {
      groupIds.push(item.label)
    })
    this.pickerGroupCn = groupIds.join('/')
    this.forwardDialog.groupId = [res[0].id, res[1].id]
  }
}
